import "./RevenueTimeline.scss";
import { Component, Vue, Prop } from "vue-property-decorator";
import { CreateElement, VNode } from "vue/types/umd";

@Component
class RevenueTimeline extends Vue {
  @Prop() items;

  genItem(item) {
    const h = this.$createElement;

    return h("div", { staticClass: "timeline__item" }, [
      h("div", { staticClass: "timeline__body" }, [
        h("div", { staticClass: "font-weight-bold" }, [item.text]),
        h("div", { staticClass: "caption text--secondary f-number-field" }, [
          item.label
        ])
      ]),
      h("div", { staticClass: "timeline__dot" })
    ]);
  }

  render(h: CreateElement): VNode {
    return h("div", { staticClass: "revenue-timeline" }, [
      this.items.map(item => this.genItem(item))
    ]);
  }
}

export default RevenueTimeline;
